import { Metamodel } from 'app/model/base/model';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';
import { Owned } from 'app/model/base/named';
import { DataFlowDSLAdapterRegistry } from 'shell-models-lib';
import { SnowflakeV2Settings } from 'app/model/dataflow/dataset-settings/snowflake-v2-settings';
import { SnowflakeTableAdapter } from './snowflake.adapter';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(SnowflakeV2Settings)
})
export class SnowflakeV2TableAdapter extends SnowflakeTableAdapter {
    public override async toSourceDSL(setting: SnowflakeV2Settings): Promise<string[]> {
        const props = await super.toSourceDSL(setting);
        props.push(`store: 'snowflakeV2'`);
        return props;
    }

    public override async toSinkDSL(setting: SnowflakeV2Settings): Promise<string[]> {
        const props = await super.toSinkDSL(setting);
        props.push(`store: 'snowflakeV2'`);
        return props;
    }

    public override async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<SnowflakeV2Settings> {
        return (await super.toSourceModel(owner, configs, handledConfigs)) as SnowflakeV2Settings;
    }

    public override async toSinkModel(
        owner: DataFlowSink,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<SnowflakeV2Settings> {
        const setting = (await super.toSinkModel(owner, configs, handledConfigs)) as SnowflakeV2Settings;
        if (configs.has('stageInsert') && configs.get('stageInsert') === 'true') {
            owner.snowflakeStageInsert = true;
            handledConfigs.push('stageInsert');
        }
        return setting;
    }

    protected override _generateSetting(owner: DataFlowSource | DataFlowSink): SnowflakeV2Settings {
        const result = Owned.create<SnowflakeV2Settings>(SnowflakeV2Settings.MODEL, owner);
        result.initialize(undefined);
        return result;
    }
}
